import React from "react";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import { Button, Box, Divider } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { dateSavedToDisplay } from "../../constants/vtrTrip";
import useScrollToTop from "../../components/CustomHooks/useScrollToTop";

function GarfoIvrList({ ivrs, vesselNbr, handleAction }) {
  useScrollToTop();

  const { ivr_projects = {}, efp = [], rsa = [], das = {} } = ivrs;
  const { reporting = false, trip_list = [] } = das;
  const projects = { ...ivr_projects };
  const trips = [...rsa, ...efp];
  const openTrips = { rsa, efp, das: trip_list };

  const getTripByProjectCode = (trips, project_code) => {
    let founded = false;
    trips.find(
      (trip) => (founded = trip.project_code === project_code ? true : false)
    );
    return founded;
  };

  const displayData = (type, data) => {
    return type === "das" ? (
      <>
        {`Species: ${data.speciescd}`}
        <br />
        {`Gear Type: ${data.gear_type}`}
      </>
    ) : (
      <>
        {`Project Code: ${data.project_code}`}
        <br />
        {`Confirmation Number: ${
          data.trip_confirmnbr ? data.trip_confirmnbr : ""
        }`}
      </>
    );
  };

  return (
    <Box display="flex" flexDirection="column" m={1} p={1}>
      <Box display="flex" justifyContent="center">
        <List
          component="nav"
          subheader={
            <ListSubheader
              component="div"
              id="das_trips"
              className="spaceBetweenLeft"
            >
              <h2>DAS Trips</h2>
              {reporting && (
                <Button
                  color="primary"
                  onClick={() =>
                    handleAction({
                      enabled: true,
                      tripType: "das",
                      type: "das_open",
                      endPoint: "new-ivr-trip",
                    })
                  }
                  disabled={Object.entries(trip_list).length > 0}
                >
                  <NavigateNextIcon />
                </Button>
              )}
            </ListSubheader>
          }
          sx={{
            border: "solid 1px #ACACAC",
            borderRadius: "5px",
            width: "100%",
            maxWidth: 320,
            position: "relative",
            overflow: "auto",
            maxHeight: 650,
          }}
          dense
        />
      </Box>
      <Box display="flex" justifyContent="center">
        <List
          component="nav"
          subheader={
            <ListSubheader component="div" id="open_trips">
              <h2>Open Trips</h2>
            </ListSubheader>
          }
          sx={{
            width: "100%",
            maxWidth: 320,
            position: "relative",
            overflow: "auto",
            maxHeight: 650,
            border: "solid 1px #ACACAC",
            borderRadius: "5px",
            marginTop: "20px",
          }}
          dense
        >
          <Divider />
          {Object.entries(openTrips).map(([tripType, trip]) => {
            return trip.map((data) => {
              return (
                <ListItem
                  button
                  key={data.trip_id}
                  onClick={() =>
                    handleAction({
                      enabled: true,
                      trip_id: data.trip_id,
                      tripType: tripType,
                      projectCode: data.project_code,
                      type: `${tripType}_close`,
                      endPoint: "ivr-close-trip",
                    })
                  }
                >
                  <ListItemText>
                    {`Trip Type: ${tripType.toUpperCase()}`}
                    <br />
                    {displayData(tripType, data)}
                  </ListItemText>
                  <ListItemIcon>
                    <NavigateNextIcon style={{ marginLeft: "10px" }} />
                  </ListItemIcon>
                </ListItem>
              );
            });
          })}
        </List>
      </Box>
      <Box display="flex" justifyContent="center">
        {Object.entries(projects).length > 0 && (
          <List
            component="nav"
            subheader={
              <ListSubheader component="div" id="projects">
                <h2>Projects</h2>
              </ListSubheader>
            }
            sx={{
              width: "100%",
              maxWidth: 320,
              position: "relative",
              overflow: "auto",
              maxHeight: 650,
              border: "solid 1px #ACACAC",
              borderRadius: "5px",
              marginTop: "20px",
            }}
            dense
          >
            <Divider />
            {Object.entries(projects).map(([type, project]) => {
              return project
                .sort((a, b) => a.project_code.localeCompare(b.project_code))
                .map((data) => {
                  return (
                    <ListItem
                      button
                      key={data.project_code}
                      onClick={() =>
                        handleAction({
                          enabled: true,
                          tripType: type,
                          projectCode: data.project_code,
                          type: "open",
                          endPoint: "new-ivr-trip",
                        })
                      }
                      disabled={getTripByProjectCode(trips, data.project_code)}
                    >
                      <ListItemText>
                        {`Type: ${type.toUpperCase()}`}
                        <br />
                        {`Code: ${data.project_code}`}
                        <br />
                        {`End Date: ${
                          data.end_date ? dateSavedToDisplay(data.end_date) : ""
                        }`}
                      </ListItemText>
                      <ListItemIcon>
                        <NavigateNextIcon style={{ marginLeft: "10px" }} />
                      </ListItemIcon>
                    </ListItem>
                  );
                });
            })}
          </List>
        )}
      </Box>

      {/* // TODO: move object to its own file */}
      <Box display="flex" justifyContent="center">
        <Breadcrumbs arial-aria-label="breadcrumb">
          <Link
            to={`${process.env.PUBLIC_URL}/das-open-block`}
            state={{ permitNbr: vesselNbr }}
          >
            <Button>DAS Open Block</Button>
          </Link>
          |
          <Link
            to={`${process.env.PUBLIC_URL}/vms-declaration`}
            state={{ permitNbr: vesselNbr }}
          >
            <Button>VMS Redeclaration</Button>
          </Link>
        </Breadcrumbs>
      </Box>
    </Box>
  );
}

export default GarfoIvrList;
